export default __webpack_public_path__ + "static/media/cnn_en_rudl_a2.fb531564.mp3";